// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "productionXy/js/" + chunkId + ".1781681860623.js";
};